"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoyageAITimeoutError = void 0;
class VoyageAITimeoutError extends Error {
    constructor() {
        super("Timeout");
        Object.setPrototypeOf(this, VoyageAITimeoutError.prototype);
    }
}
exports.VoyageAITimeoutError = VoyageAITimeoutError;
